<template>
	<div class="">
		<!--头部-->
		<Header @toggleLang="toggleLang" @refreshSearch="refreshSearch"></Header>
		<div class="m-hxbk">
			<div class="hxbk_count no-padding-top">
				<div class="wow fadeInUp animated" data-wow-delay="0.5s" data-wow-offset='0'>
					<img class="list_img" :src="zidiyiData" />
				</div>
				<div class="m-result " v-if="types=='shop'">
					<div class="row" v-if="proList.length>0">
						<div class="item col-xs-4 col-lg-3  " v-for="(item,index) in proList">
							<a :href="item.outlink" target="_blank">
								<div class="photos">
									<img class="photo" :src="item.image" />
									<div class="ewm css3"><img :src="item.ewm" /></div>
									<div class="mask css3"></div>
								</div>
								<div class="title line-2">{{item.title}}</div>
							</a>
						</div>
					</div>
					<div class="row" v-else>
						暂无数据~
					</div>
					<!-- 分页 -->
					<div class="fenye">
						<el-pagination @size-change="yshandleSizeChange" @current-change="yshandleCurrentChange"
							:current-page="yscurrentPage" background :page-size="per_page"
							layout="total, prev, pager, next, jumper" :total="total">
						</el-pagination>
					</div>
				</div>

				<div class="m-result " v-if="types=='news'">
					<div class="row" v-if="arcList.length>0">
						<div class="item col-xs-4 col-lg-3  " v-for="(item,index) in arcList"  @click="(item.outlink=='#' || item.outlink=='') ?go(item.id):go_open(item.outlink)">
							<div class="photos">
								<img class="photo" :src="item.image" />
							</div>
							<div class="title line-2">{{item.cn_title}}</div>
							<div class="time line-2">{{item.publishtime_text}}</div>
						</div>
					</div>
					<div class="row" v-else>
						暂无数据~
					</div>
					<!-- 分页 -->
					<div class="fenye">
						<el-pagination @size-change="yshandleSizeChange" @current-change="yshandleCurrentChange"
							:current-page="yscurrentPage" background :page-size="per_page"
							layout="total, prev, pager, next, jumper" :total="total">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from '@/components/Header'
	import Footer from '@/components/Footer'

	import {
		WOW
	} from 'wowjs'

	export default {
		components: {
			Header,
			Footer
		},
		name: 'coreplate',
		data() {
			return {
				currentPage4: 1,
				yscurrentPage: 1,
				parent_id: 9,
				zidiyiData: '',
				type: false,
				per_page: 8,
				page: 1,
				proList: [], //商品列表
				arcList: [], //资讯列表
				total: 0,
				company_id: 6, //公司ID
				lang: localStorage.getItem('lang') || 'CN',
				types: 'news',
				keyword: '',
			}
		},
		created() {


			this.getZidiyiData() //自定义图片
			this.addLocatPath()
			var wow = new WOW({
				boxClass: 'wow',
				animateClass: 'animated',
				offset: 0,
				mobile: true,
				live: true
			});
			wow.init();

		},

		mounted() {
			this.company_id = this.$route.query.id || this.company_id
			if (this.$route.query.keyword) {
				this.types = this.$route.query.type
				this.keyword = this.$route.query.keyword
				if (this.types == 'shop') { //商城列表
					this.getProductList('')
				}
				if (this.types == 'news') { //新闻列表
					this.getArchivesList()
				}
			}
			if (this.types == 'news') {
				this.getArchivesList()
			} else {
				this.getProductList('')
			}
		},
		methods: {
			refreshSearch(str1, str2) {
				this.types = str1
				this.keyword = str2
				console.log(this.keyword, str1)

				if (str1 == 'news') { //新闻列表
					this.getArchivesList()
				}
				if (str1 == 'shop') { //商城列表
					this.getProductList('')
				}
			},
			getArchivesList() { //新闻搜索
				let data = {
					channel_id: '',
					per_page: this.per_page,
					page: this.page,
					keyword: this.keyword
				}
				this.$axios.get("/api/jx/archives_list", {
					params: data
				}).then((res) => {
					console.log(res.data.data, 99999)
					if (res.data.code == 1) {
						this.arcList = res.data.data.data
						this.total = res.data.data.total
					}
				}).catch(err => {});
			},
			toggleLang(str) {
				localStorage.setItem('lang', str)
				this.lang = str
			},
			addLocatPath() {
				let data = {
					directions: '搜索',
					path: window.location.href
				}


				this.$axios.get("/api/jx/add_pv", {
					params: data
				}).then((res) => {}).catch(err => {});
			},
			// 获取自定义图片
			getZidiyiData() {
				let data = {}
				this.$axios.get("/api/jx/get_file_all", {
					params: data
				}).then((res) => {
					this.zidiyiData = res.data.data.files
				}).catch(err => {});
			},
			getProductList(id) {
				let data = {
					company_id: id,
					per_page: this.per_page,
					page: this.page,
					keyword: this.keyword
				}

				this.$axios.get("/api/jx/product_list", {
					params: data
				}).then((res) => {
					if (res.data.code == 1) {
						this.proList = res.data.data.data
						this.total = res.data.data.total
					}
				}).catch(err => {});
			},

			handleSizeChange(val) {
				console.log(`每页 ${val} 条`)
			},
			handleCurrentChange(val) {
				this.page = val
				console.log(`当前页: ${val}`)
			},
			yshandleSizeChange(val) {
				console.log(`每页 ${val} 条`)
			},
			yshandleCurrentChange(val) {
				this.page = val
				if (this.types == 'news') {
					this.getArchivesList()
				} else {
					this.getProductList()
				}
				console.log(`当前页: ${val}`)
			},
			go(id) {
				this.$router.push({
					path: `new_detail?id=${id}`
				})
			},
			
			go_open(url) {
				if (url) {
					window.open(url, "_blank");
				}
			},
			
		}
	}
</script>
<style lang="scss" scoped>
	a:hover {
		text-decoration: none;
	}
	.m-hxbk {
		.hxbk_count {
			padding: 30px;

			.m-result {
				margin: 50px auto 0;
				max-width: 1400px;
				overflow: hidden;

				.item {
					overflow: hidden;
					position: relative;
					margin-bottom: 10px;

					.photos {
						width: 100%;
						height: 400px;
						position: relative;

						.photo {
							width: 100%;
							object-fit: cover;
							height: 400px;
						}

						.mask {
							width: 100%;
							height: 100%;
							position: absolute;
							top: 0;
							left: 0;
							z-index: 2;
							opacity: 0;
							background: rgba(0, 0, 0, .5);
						}
					}

					.ewm {
						width: 140px;
						height: 140px;
						position: absolute;
						top: 50%;
						left: 50%;
						z-index: 3;
						margin: -70px 0 0 -70px;
						transform: scale(0);
						-webkit-transform: scale(0);
						-moz-transform: scale(0);
						-o-transform: scale(0);
						-ms-transform: scale(0);

						img {
							width: 140px;
							height: 140px;
							object-fit: cover;
						}

					}

					&:hover .ewm {
						transform: scale(1);
						-webkit-transform: scale(1);
						-moz-transform: scale(1);
						-o-transform: scale(1);
						-ms-transform: scale(1);
					}
				}

				&:hover .mask {
					opacity: 1;
				}

				.title {
					margin-top: 10px;
					height: 60px;
					line-height: 30px;
					color: #333333;
					font-size: 18px;
				}

				.title:hover {
					color: #006170;
					cursor: pointer;
				}
			}
		}
	}
	.fenye {
		margin-top: 50px;
		text-align: center;
	}
	.el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #006170;
	}
	@media screen and (min-width: 1200px) and (max-width: 1399px) {
		.item img {
			height: 300px;
		}
	}

	@media screen and (min-width: 899px) and (max-width: 1199px) {
		.item img {
			height: 250px;
		}
	}
</style>
